type IconProps = React.ComponentProps<'svg'>

export function Globe01Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(1.25, 1.25)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.75 0c5.93706 0 10.75 4.81294 10.75 10.75 0 5.93706-4.81294 10.75-10.75 10.75-5.93706 0-10.75-4.81294-10.75-10.75 0-5.93706 4.81294-10.75 10.75-10.75z m-9.2168 11.5c0.33604 4.18652 3.45699 7.58375 7.51075 8.33984-1.76264-2.43593-2.80964-5.32531-3.01075-8.33984l-4.5 0z m13.9336 0c-0.20111 3.01472-1.24887 5.90381-3.01172 8.33984 4.05421-0.75575 7.17565-4.153 7.51172-8.33984l-4.5 0z m-7.92871 0c0.21826 2.96425 1.34017 5.78857 3.21191 8.0957 1.87175-2.30713 2.99365-5.13146 3.21191-8.0957l-6.42382 0z m1.50586-9.84082c-4.05384 0.75603-7.1747 4.15424-7.51075 8.34082l4.5 0c0.20112-3.01479 1.24782-5.90475 3.01075-8.34082z m1.70605 0.24414c-1.87204 2.30724-2.99363 5.13218-3.21191 8.09668l6.42382 0c-0.21828-2.9645-1.33988-5.78944-3.21191-8.09668z m1.70508-0.24414c1.76313 2.43616 2.81059 5.32583 3.01172 8.34082l4.5 0c-0.33607-4.1869-3.45742-7.58514-7.51172-8.34082z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}
